import { render, staticRenderFns } from "./RelatedArticleList.vue?vue&type=template&id=d14be86c&scoped=true&"
import script from "./RelatedArticleList.vue?vue&type=script&lang=js&"
export * from "./RelatedArticleList.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticleList.vue?vue&type=style&index=0&id=d14be86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d14be86c",
  null
  
)

export default component.exports